import { useRef } from 'react';

export const useEditableCellClickHandlers = () => {
  const copyTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isDoubleClickRef = useRef(false);

  const handleClick = (onClick: () => void) => {
    isDoubleClickRef.current = false;

    copyTimeoutRef.current = setTimeout(() => {
      if (!isDoubleClickRef.current) {
        onClick?.();
      }
      copyTimeoutRef.current = null;
    }, 300);
  };

  const handleDoubleClick = (onDoubleClick: () => void) => {
    isDoubleClickRef.current = true;

    if (copyTimeoutRef.current) {
      clearTimeout(copyTimeoutRef.current);
      copyTimeoutRef.current = null;
    }

    onDoubleClick?.();
  };

  return { handleClick, handleDoubleClick };
};
